import {endpoints} from '@kapitalist/contract/endpoints'
import type {
  TPathPiecesOf,
  TRequestOf,
  TResponseOf,
} from '@kapitalist/contract/endpoints/types'
import {PostApi} from '~/api/client'
import GetGameData from '~/api/endpoints/game/GetGameData'

const endpoint = endpoints.spectator.revokeSpectatorPermission
type Params = TRequestOf<typeof endpoint>
type PathPieces = TPathPiecesOf<typeof endpoint>
type Response = TResponseOf<typeof endpoint>

/**
 * A player in a game can deny a spectator the right to see their hand,
 * either outright or after previously approving it.
 */
export default class RevokeSpectatorPermission extends PostApi<typeof endpoint>() {
  constructor() {
    super(endpoint)
  }

  protected getMockResponse(params: Params, pathPieces: PathPieces): Response {
    return GetGameData.mockResponseWithMockConfig({
      pathPieces: {
        ...pathPieces,
        maybeGameId: pathPieces.gameId,
      },
    })
  }

  protected getPath(pathPieces: PathPieces) {
    return endpoint.path(pathPieces)
  }

  protected transformResponse(r: Response) {
    return r
  }
}
